export default {
  '': 'Unknown device',
  all: 'Unknown device',
  android: 'Android device',
  androidtv: 'Android TV',
  appletv: 'Apple TV',
  chromecast: 'Chromecast',
  comcast: 'Unknown device',
  feeds: 'Unknown device',
  firetv: 'Fire TV',
  ios: 'iOS device',
  lg: 'LG Smart TV',
  oculus: 'Oculus',
  roku: 'Roku',
  roku_lowpower: 'Roku',
  samsung: 'Samsung Smart TV',
  smarttv: 'Smart TV',
  tvos: 'Apple TV',
  vizio: 'Vizio Smart TV',
  web: 'Web browser',
  webos: 'Unknown device',
  witbe: 'Unknown device',
  xbox: 'Xbox',
};
